import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_PARTICIPANT_PROFILE,
  CREATE_USER_PROFILE,
} from "../graphql/mutations";
import { germanStates } from "./germanStates.js";
import countries from "i18n-iso-countries";
import { GENDERS, STARTUPROLES, AHS, FRM, FAG } from "../graphql/queries";
import CustomSelect from "./CustomSelect";
import { Link } from "react-router-dom";
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

// eslint-disable-next-line no-unused-vars
const axios = require("axios");

function ParticipantProfile(props) {
  const confirmationCode = props.match.params.code;
  const startupId = props.match.params.startupId;
  const type = props?.match?.url?.split("/")[1];

  const [valid, setValid] = useState(false);
  const [done, setDone] = useState(false);

    useEffect(() => {
        const confirmationUrl = process.env.REACT_APP_MAIL_CONFIRMATION_PROFILE_CONFIRMATION_URL || 'https://f1j07exi8h.execute-api.eu-central-1.amazonaws.com/dev/profile-confirmation'
        fetch(`${confirmationUrl}?code=${confirmationCode}&startupid=${startupId}`)
            .then(response => {
                setValid(response.status === 200)
                setDone(true)
            })
            .catch(_ => setDone(true))
    }, [confirmationCode, startupId])
  
  // Fetch Gender
  // Fetch GENDERS
  const [genders, setGenders] = useState();
  const genderQuery = useQuery(GENDERS);
  useEffect(() => {
    if (genderQuery?.data) {
      const dataReceived = genderQuery?.data.gdrRanges?.data.map((gender) => ({
        value: gender.id,
        label: gender.attributes.value,
      }));

      setGenders(dataReceived);
    }
  }, [genderQuery?.data, genderQuery.error]);

  // Fetch STARTUPROLES
  const [startuproles, setStartuproles] = useState();
  const startuprolesQuery = useQuery(STARTUPROLES);
  useEffect(() => {
    if (startuprolesQuery?.data) {
      const dataReceived = startuprolesQuery?.data.rolRanges?.data.map(
        (role) => ({
          value: role.id,
          label: role.attributes.value,
        })
      );

      setStartuproles(dataReceived);
    }
  }, [startuprolesQuery?.data, startuprolesQuery.error]);

  // Fetch AHS
  const [ahss, setAhss] = useState();
  const ahssQuery = useQuery(AHS);
  useEffect(() => {
    if (ahssQuery?.data) {
      const dataReceived = ahssQuery?.data.ahsRanges?.data.map((ahs) => ({
        value: ahs.id,
        label: ahs.attributes.value,
      }));

      setAhss(dataReceived);
    }
  }, [ahssQuery?.data, ahssQuery.error]);

  // Fetch FRM
  const [frms, setFrms] = useState();
  const frmsQuery = useQuery(FRM);
  useEffect(() => {
    if (frmsQuery?.data) {
      const dataReceived = frmsQuery?.data.frmRanges?.data.map((frm) => ({
        value: frm.id,
        label: frm.attributes.value,
      }));

      setFrms(dataReceived);
    }
  }, [frmsQuery?.data, frmsQuery.error]);

  // Fetch FAG
  const [fags, setFags] = useState();
  const fagsQuery = useQuery(FAG);
  useEffect(() => {
    if (fagsQuery?.data) {
      const dataReceived = fagsQuery?.data.fagRanges?.data.map((fag) => ({
        value: fag.id,
        label: fag.attributes.value,
      }));

      setFags(dataReceived);
    }
  }, [fagsQuery?.data, fagsQuery.error]);

  useEffect(() => {
    const countryNames = countries.getNames("en");
    const formattedCountryList = Object.keys(countryNames).map((code) => {
      return { value: code, label: countryNames[code] };
    });
    setCountryList(formattedCountryList);
  }, []);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  /* Startup states */
  const [yearBorn, setYearBorn] = useState("");
  const [yearBornerror, setYearBornError] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [startupSinceerror, setStartupSinceError] = useState("");

  /* Startup Selects */
  const [gender, setGender] = useState("");
  const [genderError, setGenderError] = useState("");
  function handleChangeGender(selectedOption) {
    setGender(selectedOption.value);
    setGenderError("");
  }

  const [startuprole, setStartuprole] = useState("");
  const [startuproleError, setStartuproleError] = useState("");
  function handleChangeStartuprole(selectedOption) {
    setStartuprole(selectedOption.value);
    setStartuproleError("");
  }

  // Add missing state variables and error variables
  const [ahs, setAhs] = useState("");
  const [ahsError, setAhsError] = useState("");
  function handleChangeAhs(selectedOption) {
    setAhs(selectedOption.value);
    setAhsError("");
  }

  const [frm, setFrm] = useState("");
  const [frmError, setFrmError] = useState("");
  function handleChangeFrm(selectedOption) {
    setFrm(selectedOption.value);
    setFrmError("");
  }

  const [fag, setFag] = useState("");
  const [fagError, setFagError] = useState("");
  function handleChangeFag(selectedOption) {
    setFag(selectedOption.value);
    setFagError("");
  }

  const [fagl, setFagl] = useState("");
  function handleChangeFagl(selectedOption) {
    setFagl(selectedOption.label);
  }

  const [wfw, setWfw] = useState("");
  const [wfwError, setWfwError] = useState("");
  function handleChangewfw(selectedOption) {
    setWfw(selectedOption.label);
    setWfwError("");
  }

  const [success, setSuccess] = useState();

  const [createParticipiantProfile, { loadingParticipantProfile }] =
    useMutation(
      type === "participant-profile"
        ? CREATE_PARTICIPANT_PROFILE
        : CREATE_USER_PROFILE,
      {
        onCompleted: (providerData) => {
          setGenderError("");
          setYearBornError("");
          setStartupSinceError("");
          setStartuproleError("");
          setAhsError("");
          setFrmError("");
          setFagError("");
          setWfwError("");
          setSuccess(true);
        },
        onError: (error) => {
          if (error.message === "This attribute must be unique") {
            //setPersonalMailError('Es gibt schon ein Konto mit dieser Email-Adresse.')
          }
          if (
            [
              "FOU must be greater than or equal to 1990",
              "FOU must be less than or equal to 2030",
            ].includes(error.message)
          ) {
            // setFoundingYearError('Bitte eine Jahreszahl zwischen 1990 und 2030 eingeben.')
          }
        },
      }
    );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (gender === "") {
      setGenderError("Please select a valid entry.");
      document.getElementById("select-gender").scrollIntoView();
    } else if (!parseInt(yearBorn)) {
      setYearBornError("Please type in a valid year.");
      document.getElementById("select-yearBorn").scrollIntoView();
    } else if (startuprole === "") {
      setStartuproleError("Please select a valid entry.");
      document.getElementById("select-startuprole").scrollIntoView();
    } else if (ahs === "") {
      setAhsError("Please select a valid entry.");
      document.getElementById("select-ahs").scrollIntoView();
    } else if (frm === "") {
      setFrmError("Please select a valid entry.");
      document.getElementById("select-frm").scrollIntoView();
    } else if (fag === "") {
      setFagError("Please select a valid entry.");
      document.getElementById("select-fag").scrollIntoView();
    } else if (wfw === "") {
      setWfwError("Please select a valid entry.");
      document.getElementById("select-wfw").scrollIntoView();
    } else {
      createParticipiantProfile({
        variables: {
          GDR: gender,
          AGE: parseInt(yearBorn),
          ROL: startuprole,
          AHS: ahs,
          FRM: frm,
          FAG: fag,
          FAGL: fagl,
          WFW: wfw,
          startupid: startupId,
        },
      });
    }
  };

  return (
    <div className="absolute left-0 right-0 flex flex-col items-center overflow-y-auto bottom-14 top-20">
      {!success && valid && done && (
        <>
          <h1 className="m-2 mt-10">Complete your Profile</h1>
          <p>
            <strong>
              All data is collected anonymously and cannot be tracked back to
              you.
            </strong>
          </p>
          <form onSubmit={handleSubmit} className="w-full max-w-xl p-4 m-auto">
            <div className="flex-col w-full center">
              <label className="ml-2 align-middle inline-block">
                To which gender identity do you most identify?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-gender"
                onChange={handleChangeGender}
                options={genders}
                placeholder="e.g. male, female, diverse ..."
              />
              {genderError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{genderError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                In which year were you born?<span className="required">*</span>
              </label>
              <input
                required
                id="select-yearBorn"
                className="w-full"
                type="number"
                placeholder="e.g. 1990"
                value={yearBorn}
                onChange={(e) => setYearBorn(e.target.value)}
              ></input>
              {yearBornerror !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{yearBornerror}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                What is your role within the startup?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-startuprole"
                onChange={handleChangeStartuprole}
                options={startuproles}
                placeholder="e.g. employee, founder ..."
              />
              {startuproleError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{startuproleError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Which academic degree do you have?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-ahs"
                onChange={handleChangeAhs}
                options={ahss}
                placeholder="e.g. High School, Bachelor ..."
              />
              {ahsError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{ahsError}</p>
              )}
              <label className="ml-2 align-middle inline-block">
                Are you from FrankfurRheinMain?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-frm"
                onChange={handleChangeFrm}
                options={frms}
                placeholder="Please select"
              />
              {frmError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{frmError}</p>
              )}

              <label className="ml-2 align-middle inline-block">
                Are you from another part of Germany?
                <span className="required">*</span>
              </label>
              <CustomSelect
                id="select-fag"
                onChange={handleChangeFag}
                options={fags}
                placeholder="Please select"
              />
              {fagError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{fagError}</p>
              )}

              {/* Zeige das Dropdown für Bundesländer nur wenn die Antwort 'Ja' ist */}
              {fag === "1" && (
                <>
                  <label className="ml-2 align-middle inline-block">
                    Please select your state:
                    <span className="required">*</span>
                  </label>
                  <CustomSelect
                    id="select-state"
                    onChange={handleChangeFagl}
                    options={germanStates}
                    placeholder="Please select"
                  />
                </>
              )}

              <label className="ml-2 align-middle inline-block">
                From where?<span className="required">*</span>
              </label>
              <CustomSelect
                id="select-wfw"
                options={countryList}
                onChange={handleChangewfw}
                placeholder="Please select a country"
              />
              {wfwError !== "" && (
                <p className="ml-2 -mt-3 text-red-400 ">{wfwError}</p>
              )}

              <div className="flex mt-4 mb-6 ml-2 text-left items-left">
                <input required id="privacy" type="checkbox"></input>
                <label
                  htmlFor="privacy"
                  className="ml-2 align-middle inline-block"
                >
                  I agree to the{" "}
                  <a href="https://station-frankfurt.de/datenschutzerklaerung/">
                    privacy policy.
                  </a>
                  <span className="required">*</span>
                </label>
              </div>
              <button
                id="submit"
                type="submit"
                className="w-full mb-4 tertiary link-bold"
                disabled={loadingParticipantProfile}
              >
                Submit form
              </button>
            </div>
          </form>
        </>
      )}
      {success && done && valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>
            We have received the registration of your participant profile.
          </h2>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to the map
            </li>
          </Link>
        </div>
      )}
      {done && !valid && (
        <div className="items-center mx-auto mt-8 text-center">
          <h2>There was an error with your token.</h2>
          <p className="mt-4 text-copy-main-regular">
            Please verify that your link is valid and not expired.
          </p>
          <Link to="/" className="items-center w-full">
            <li className="float-none w-56 mx-auto mt-8 list-none topbar-link-primary">
              Back to map
            </li>
          </Link>
        </div>
      )}
    </div>
  );
}

export default ParticipantProfile;
